// extracted by mini-css-extract-plugin
export default {"wrapper":"EditPolicyGeneralForm_wrapper__Tcne4","submitWrapper":"EditPolicyGeneralForm_submitWrapper__ms-4b"};